import { Button, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getCourses } from '../../../../services/courseService';
const { Option } = Select;

const CommentsSearch = ({ onReset, onFinish, form, initialValues }) => {
  const [filteredCourseOffers, setFilteredCourseOffers] = useState([]);
  const [courses, setCourses] = useState([]);

  useEffect((e) => {
    getCourses()
      .then((response) => {
        const courseList = response.data.paginatedList;
        let data = [];
        courseList.forEach((course) => {
          data.push({
            label: course.code,
            value: course.code,
            description: course.description
          });
        });
        setCourses(data);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  }, []);

  const filterItems = (value, originalData, setter) => {
    const filtered = originalData.filter((item) => {
      const substring = item.label.substr(0, value.length);
      return substring.toLowerCase() === value.toLowerCase();
    });
    setter(filtered);
  };

  const getFilteredCourseOffers = (value) => {
    filterItems(value, courses, setFilteredCourseOffers);
  };

  const courseListOptions = courses.map((course, index) => (
    <Option value={course.label} key={index}>
      {course.label} - {course.description}
    </Option>
  ));

  return (
    <Form form={form} onFinish={onFinish} initialValues={initialValues}>
      <Row gutter={16}>
        <Col span={10}>
          <Form.Item name="courseCode">
            <Select
              placeholder={'Select Course Offer Code'}
              showSearch={true}
              onSearch={getFilteredCourseOffers}>
              {courseListOptions}
            </Select>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label="Email" name="email">
            <Input />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label="User Id" name="userId">
            <Input />
          </Form.Item>
        </Col>

        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={10}>
          <Form.Item label="Subunit Code" name="subunitCode">
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

CommentsSearch.propTypes = {
  onFinish: PropTypes.func,
  onReset: PropTypes.func,
  initialValues: PropTypes.object,
  form: PropTypes.any //change
};

CommentsSearch.defaultProps = {};

export default CommentsSearch;
